import { useState } from "react";
import { createContainer } from "unstated-next";
import { LoggingService } from "../services/LoggingService";

type AppError = {
  title: string;
  message: string[];
  error?: Error;
  reloadable?: boolean;
  retryCount: number;
};

/**
 * エラーコンテナ
 */
const useErrorContainer = () => {
  const [error, setError] = useState<AppError>({
    title: "",
    message: [],
    reloadable: true,
    retryCount: 0,
  });

  /**
   * カスタムエラーを設定
   * @param title エラー画面タイトル
   * @param message エラーメッセージ
   * @param user ユーザーID
   * @param reloadable 再読み込み可能かどうか
   * @param err エラーオブジェクト
   *
   */
  const setCustomError = (
    title: string,
    message: string[],
    user: string,
    reloadable = true,
    err?: Error
  ) => {
    console.log(err);

    if (err) {
      LoggingService().logging(user, err);
    }

    error.title = title;
    error.message = message;
    error.error = err;
    error.reloadable = reloadable;

    setError({ ...error });
  };

  /**
   * デフォルトエラーを設定
   * @param user ユーザーID
   * @param err エラーオブジェクト
   */
  const setDefaultError = (user: string, err: Error) => {
    console.log(err);

    LoggingService().logging(user, err);

    error.title = "サーバーエラー";
    error.message = [
      "サーバーエラーが発生しました。",
      "ご迷惑をお掛けいたしますが、",
      "しばらく待ってから再度お試しください。",
    ];
    error.error = err;

    setError({ ...error });
  };

  /**
   * エラーがあるか確認する
   * @returns true: エラーあり | false: エラーなし
   */
  const hasError = () => {
    if (error.title) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * エラーをクリアする
   */
  const resetError = () => {
    error.title = "";
    error.message = [];
    setError({ ...error });
  };

  /**
   * リトライ用にエラー情報をクリアする
   */
  const retry = () => {
    error.retryCount += 1;
    error.title = "";
    error.message = [];
    setError({ ...error });
  };

  return {
    error,
    setCustomError,
    setDefaultError,
    hasError,
    resetError,
    retry,
  };
};

export const ErrorContainer = createContainer(useErrorContainer);
